export default "__VITE_ASSET__DjZDdjkf__"